import { ArrowTopRightOnSquareIcon, CheckCircleIcon, CloudArrowDownIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { useEffect } from "react";
//import Pagination from "../components/pagination";
import { useState } from "react";
import { useSelector } from "react-redux";
import { translations } from '../../../../utils/language';
import imgEmpty from "../../../../assets/imgs/image-empy.png";
import {
    getCheckoutBadgeClass,
    getCheckoutBadgeStyle,
    getCheckoutButtonClass,
    getCheckoutButtonStyle,
} from "../ColorSwatchPicker";
//import { BarFilters, BarFiltersIcon, BarFiltersLeft, Search } from "./styled";
//import FiltersOrder from "../components/filters-order";


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function PreviewCheckout() {

    const [search, setsearch] = useState("")
    const controlConfig = useSelector((state) => state.reducerControlConfig);
    const language = useSelector((state) => state.reducerLanguage);

    useEffect(() => {
        console.log("controlConfig", controlConfig)
    }, [controlConfig])

    const checkoutColor = controlConfig.checkout_color || "gray";
    const getColorButton = () => getCheckoutButtonClass(checkoutColor);
    const getColorButtonStyle = () => getCheckoutButtonStyle(checkoutColor);
    const getColorType = () => getCheckoutBadgeClass(checkoutColor);
    const getColorTypeStyle = () => getCheckoutBadgeStyle(checkoutColor);
    const getColorMedia = () => getCheckoutBadgeClass(checkoutColor);
    const getColorMediaStyle = () => getCheckoutBadgeStyle(checkoutColor);


    return (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", margin: "34px 0px" }}>
            <div style={{ borderRadius: "4px", maxWidth: "1200px", width: "100%" }} className="bg-white py-10">
                <div style={{ margin: "0px 20px" }}>
                    <h1 className="text-base font-semibold leading-6 text-gray-900">{controlConfig.checkout_message_title}</h1>
                    <p className="mt-2 text-sm text-gray-700">
                        {controlConfig.checkout_message}
                    </p>
                </div>
                {/* <BarFilters>
                    <span style={{ display: "flex", justifyContent: "space-between" }}>
                        <BarFiltersLeft>
                            <Search>
                                <span>
                                    <MagnifyingGlassIcon style={{ width: "20px" }} />
                                </span>
                                <input onKeyPress={(e) => { e.key == "Enter" && alert("teste") }} type='text' placeholder='Pesquisar por nomes...' value={search} onChange={(e) => { setsearch(e.target.value) }} />
                            </Search>
                        </BarFiltersLeft>
                        <BarFiltersIcon>
                            <div style={{ display: "flex" }}>
                                <FiltersOrder

                                />
                            </div>
                        </BarFiltersIcon>
                    </span>
                </BarFilters> */}
                <table className="mt-6  whitespace-nowrap text-left">
                    <colgroup>
                        <col className="sm:w-4/12" />
                        <col className="lg:w-4/12" />
                        <col className="lg:w-1/12" />
                        <col className="lg:w-1/12" />
                    </colgroup>
                    <thead className="border-b border-gray/10 text-sm leading-6 text-gray-700">
                        <tr>
                            <th scope="col" className="py-2 pl-4 pr-8 font-semibold sm:pl-6 lg:pl-8">
                                {translations["thema-produto"][language.data]}
                            </th>
                            <th scope="col" className="hidden py-2 pl-0 pr-8 font-semibold sm:table-cell">
                                {translations["thema-preview-midia"][language.data]}
                            </th>
                            <th scope="col" className="hidden py-2 pl-0 pr-8 font-semibold md:table-cell lg:pr-20">
                                {translations["thema-preview-tipo"][language.data]}
                            </th>
                            <th scope="col" className="hidden py-2 pl-0 pr-4 text-right font-semibold sm:table-cell sm:pr-6 lg:pr-8">
                                {translations["thema-download"][language.data]}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray/5">

                        {Array(window.screen.height > 800 ? 3 : 2).fill(
                            <tr key={"item.commit"}>
                                <td className="py-2 pl-4 pr-8 sm:pl-6 lg:pl-8">
                                    <div className="flex items-center gap-x-4">
                                        <img alt="" src={imgEmpty} className="h-8 w-8 rounded" />
                                        <div className="truncate text-sm font-medium leading-6 text-gray">{translations["thema-preview-produto"][language.data]}</div>
                                    </div>
                                </td>
                                <td className="hidden py-2 pl-0 pr-4 sm:table-cell sm:pr-8">
                                    <div className="flex gap-x-3">
                                        <div className="font-mono text-sm leading-6 text-gray-700">{"eBook"}</div>
                                        {"item.size" != null && <div className={getColorMedia()} style={getColorMediaStyle()}>
                                            {"10MB"}
                                        </div>}
                                    </div>
                                </td>
                                <td className="hidden py-2 pl-0 pr-4 text-right text-sm leading-6 text-gray-400 sm:table-cell sm:pr-6 lg:pr-8">
                                    <div className="flex gap-x-3">
                                        <div className={getColorType()} style={getColorTypeStyle()}>
                                            {"PDF"}
                                        </div>
                                    </div>
                                </td>
                                <td className="py-4 pl-0 pr-0 text-sm leading-6 sm:pr-0 lg:pr-6"
                                >
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <button
                                            //onClick={() => { download(item) }}
                                            type="button"
                                            className={getColorButton()}
                                            style={getColorButtonStyle()}
                                        >
                                            < CloudArrowDownIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                            {controlConfig.checkout_button}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {Array(window.screen.height > 800 ? 3 : 1).fill(
                            <tr key={"item.commit"}>
                                <td className="py-2 pl-4 pr-8 sm:pl-6 lg:pl-8">
                                    <div className="flex items-center gap-x-4">
                                        <img alt="" src={imgEmpty} className="h-8 w-8 rounded" />
                                        <div className="truncate text-sm font-medium leading-6 text-gray">{translations["thema-preview-produto"][language.data]}</div>
                                    </div>
                                </td>
                                <td className="hidden py-2 pl-0 pr-4 sm:table-cell sm:pr-8">
                                    <div className="flex gap-x-3">
                                        <div className="font-mono text-sm leading-6 text-gray-700">{translations["thema-preview-imagens"][language.data]}</div>
                                        {null != null && <div className="rounded bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-600 shadow-sm hover:bg-blue-100">
                                            {""}
                                        </div>}
                                    </div>
                                </td>
                                <td className="hidden py-2 pl-0 pr-4 text-right text-sm leading-6 text-gray-400 sm:table-cell sm:pr-6 lg:pr-8">
                                    <div className="flex gap-x-3">
                                        <div className={getColorType()} style={getColorTypeStyle()}>
                                            {"URL"}
                                        </div>
                                    </div>
                                </td>
                                <td className="py-4 pl-0 pr-0 text-sm leading-6 sm:pr-0 lg:pr-6"
                                >
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <button
                                            //onClick={() => { download(item) }}
                                            type="button"
                                            className={getColorButton()}
                                            style={getColorButtonStyle()}
                                        >
                                            < ArrowTopRightOnSquareIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                            {controlConfig.checkout_button_link}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
                {/* <Pagination setPage={setpage} items={filterProducts} /> */}
            </div>
        </div>
    )
}
